function gm_authFailure() {
    Shopify.designMode && (theme.$currentMapContainer.addClass("page-width map-section--load-error"), theme.$currentMapContainer.find(".map-section__content-wrapper").remove(), theme.$currentMapContainer.find(".map-section__wrapper").html('<div class="errors text-center" style="width: 100%;">' + theme.strings.authError + "</div>"))
}
window.theme = window.theme || {}, window.slate = window.slate || {}, theme.Sections = function t() {
        this.constructors = {}, this.instances = [], $(document).on("shopify:section:load", this._onSectionLoad.bind(this)).on("shopify:section:unload", this._onSectionUnload.bind(this)).on("shopify:section:select", this._onSelect.bind(this)).on("shopify:section:deselect", this._onDeselect.bind(this)).on("shopify:block:select", this._onBlockSelect.bind(this)).on("shopify:block:deselect", this._onBlockDeselect.bind(this))
    }, theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
        _createInstance: function(t, e) {
            var i = $(t),
                n = i.attr("data-section-id"),
                a = i.attr("data-section-type");
            if (e = e || this.constructors[a], !_.isUndefined(e)) {
                var s = _.assignIn(new e(t), {
                    id: n,
                    type: a,
                    container: t
                });
                this.instances.push(s)
            }
        },
        _onSectionLoad: function(t) {
            var e = $("[data-section-id]", t.target)[0];
            e && this._createInstance(e)
        },
        _onSectionUnload: function(t) {
            this.instances = _.filter(this.instances, function(e) {
                var i = e.id === t.detail.sectionId;
                return i && _.isFunction(e.onUnload) && e.onUnload(t), !i
            })
        },
        _onSelect: function(t) {
            var e = _.find(this.instances, function(e) {
                return e.id === t.detail.sectionId
            });
            !_.isUndefined(e) && _.isFunction(e.onSelect) && e.onSelect(t)
        },
        _onDeselect: function(t) {
            var e = _.find(this.instances, function(e) {
                return e.id === t.detail.sectionId
            });
            !_.isUndefined(e) && _.isFunction(e.onDeselect) && e.onDeselect(t)
        },
        _onBlockSelect: function(t) {
            var e = _.find(this.instances, function(e) {
                return e.id === t.detail.sectionId
            });
            !_.isUndefined(e) && _.isFunction(e.onBlockSelect) && e.onBlockSelect(t)
        },
        _onBlockDeselect: function(t) {
            var e = _.find(this.instances, function(e) {
                return e.id === t.detail.sectionId
            });
            !_.isUndefined(e) && _.isFunction(e.onBlockDeselect) && e.onBlockDeselect(t)
        },
        register: function(t, e) {
            this.constructors[t] = e, $("[data-section-type=" + t + "]").each((function(t, i) {
                this._createInstance(i, e)
            }).bind(this))
        }
    }), window.slate = window.slate || {}, slate.rte = {
        wrapTable: function() {
            $(".rte table").wrap('<div class="rte__table-wrapper"></div>')
        },
        iframeReset: function() {
            var t = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'),
                e = t.add(".rte iframe#admin_bar_iframe");
            t.each(function() {
                $(this).wrap('<div class="video-wrapper"></div>')
            }), e.each(function() {
                this.src = this.src
            })
        }
    }, window.slate = window.slate || {}, slate.a11y = {
        pageLinkFocus: function(t) {
            var e = "js-focus-hidden";
            t.first().attr("tabIndex", "-1").focus().addClass(e).one("blur", function i() {
                t.first().removeClass(e).removeAttr("tabindex")
            })
        },
        focusHash: function() {
            var t = window.location.hash;
            t && document.getElementById(t.slice(1)) && this.pageLinkFocus($(t))
        },
        bindInPageLinks: function() {
            $("a[href*=#]").on("click", (function(t) {
                this.pageLinkFocus($(t.currentTarget.hash))
            }).bind(this))
        },
        trapFocus: function(t) {
            var e = t.namespace ? "focusin." + t.namespace : "focusin";
            t.$elementToFocus || (t.$elementToFocus = t.$container), t.$container.attr("tabindex", "-1"), t.$elementToFocus.focus(), $(document).on(e, function(e) {
                t.$container[0] === e.target || t.$container.has(e.target).length || t.$container.focus()
            })
        },
        removeTrapFocus: function(t) {
            var e = t.namespace ? "focusin." + t.namespace : "focusin";
            t.$container && t.$container.length && t.$container.removeAttr("tabindex"), $(document).off(e)
        }
    }, theme.Currency = {
        formatMoney: function t(e, i) {
            "string" == typeof e && (e = e.replace(".", ""));
            var n = "",
                a = /\{\{\s*(\w+)\s*\}\}/,
                s = i || "${{amount}}";

            function o(t, e, i, n) {
                if (i = i || ",", n = n || ".", isNaN(t) || null === t) return 0;
                var a, s = (t = (t / 100).toFixed(e)).split(".");
                return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (s[1] ? n + s[1] : "")
            }
            switch (s.match(a)[1]) {
                case "amount":
                    n = o(e, 2);
                    break;
                case "amount_no_decimals":
                    n = o(e, 0);
                    break;
                case "amount_with_comma_separator":
                    n = o(e, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    n = o(e, 0, ".", ",");
                    break;
                case "amount_no_decimals_with_space_separator":
                    n = o(e, 0, " ");
                    break;
                case "amount_with_apostrophe_separator":
                    n = o(e, 2, "'")
            }
            return s.replace(a, n)
        }
    }, theme.Images = {
        preload: function t(e, i) {
            "string" == typeof e && (e = [e]);
            for (var n = 0; n < e.length; n++) {
                var a = e[n];
                this.loadImage(this.getSizedImageUrl(a, i))
            }
        },
        loadImage: function t(e) {
            new Image().src = e
        },
        switchImage: function t(e, i, n) {
            var a = this.imageSize(i.src),
                s = this.getSizedImageUrl(e.src, a);
            n ? n(s, e, i) : i.src = s
        },
        imageSize: function t(e) {
            var i = (e = e || "").match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/);
            return null === i ? null : i[1]
        },
        getSizedImageUrl: function t(e, i) {
            if (null === i) return e;
            if ("master" === i) return this.removeProtocol(e);
            var n = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
            if (null !== n) {
                var a = e.split(n[0]),
                    s = n[0];
                return this.removeProtocol(a[0] + "_" + i + s)
            }
            return null
        },
        removeProtocol: function t(e) {
            return e.replace(/http(s)?:/, "")
        }
    }, slate.Variants = function() {
        function t(t) {
            this.$container = t.$container, this.product = t.product, this.singleOptionSelector = t.singleOptionSelector, this.originalSelectorId = t.originalSelectorId, this.enableHistoryState = t.enableHistoryState, this.currentVariant = this._getVariantFromOptions(), $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this))
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _getCurrentOptions: function() {
                var t = _.map($(this.singleOptionSelector, this.$container), function(t) {
                    var e = $(t),
                        i = e.attr("type"),
                        n = {};
                    return "radio" !== i && "checkbox" !== i ? (n.value = e.val(), n.index = e.data("index"), n) : !!e[0].checked && (n.value = e.val(), n.index = e.data("index"), n)
                });
                return _.compact(t)
            },
            _getVariantFromOptions: function() {
                var t = this._getCurrentOptions(),
                    e = this.product.variants;
                return _.find(e, function(e) {
                    return t.every(function(t) {
                        return _.isEqual(e[t.index], t.value)
                    })
                })
            },
            _onSelectChange: function() {
                var t = this._getVariantFromOptions();
                this.$container.trigger({
                    type: "variantChange",
                    variant: t
                }), t && (this._updateMasterSelect(t), this._updateImages(t), this._updatePrice(t), this._updateSKU(t), this.currentVariant = t, this.enableHistoryState && this._updateHistoryState(t))
            },
            _updateImages: function(t) {
                var e = t.featured_image || {},
                    i = this.currentVariant.featured_image || {};
                t.featured_image && e.src !== i.src && this.$container.trigger({
                    type: "variantImageChange",
                    variant: t
                })
            },
            _updatePrice: function(t) {
                (t.price !== this.currentVariant.price || t.compare_at_price !== this.currentVariant.compare_at_price) && this.$container.trigger({
                    type: "variantPriceChange",
                    variant: t
                })
            },
            _updateSKU: function(t) {
                t.sku !== this.currentVariant.sku && this.$container.trigger({
                    type: "variantSKUChange",
                    variant: t
                })
            },
            _updateHistoryState: function(t) {
                if (history.replaceState && t) {
                    var e = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + t.id;
                    window.history.replaceState({
                        path: e
                    }, "", e)
                }
            },
            _updateMasterSelect: function(t) {
                $(this.originalSelectorId, this.$container).val(t.id)
            }
        }), t
    }(), window.Drawers = function() {
        var t = function(t, e, i) {
            if (this.nodes = {
                    $parent: $("body, html"),
                    $page: $(".page-element"),
                    $moved: $(".is-moved-by-drawer")
                }, this.config = $.extend({
                    close: ".js-drawer-close",
                    open: ".js-drawer-open-" + e,
                    openClass: "js-drawer-open",
                    dirOpenClass: "js-drawer-open-" + e
                }, i), this.position = e, this.$drawer = $("#" + t), this.$open = $(this.config.open), !this.$drawer.length) return !1;
            this.drawerIsOpen = !1, this.init()
        };
        return t.prototype.init = function() {
            this.$open.attr("aria-expanded", "false"), this.$open.on("click", $.proxy(this.open, this)), this.$drawer.find(this.config.close).on("click", $.proxy(this.close, this))
        }, t.prototype.open = function(t) {
            var e = !1;
            if (!this.drawerIsOpen) {
                if (this.$open.addClass(this.config.openClass), t ? t.preventDefault() : e = !0, t && t.stopPropagation && (t.stopPropagation(), this.$activeSource = $(t.currentTarget)), this.drawerIsOpen && !e) return this.close();
                this.nodes.$moved.addClass("is-transitioning"), this.$drawer.prepareTransition(), this.nodes.$parent.addClass(this.config.openClass + " " + this.config.dirOpenClass), this.drawerIsOpen = !0, slate.a11y.trapFocus({
                    $container: this.$drawer,
                    namespace: "drawer_focus"
                }), this.config.onDrawerOpen && "function" == typeof this.config.onDrawerOpen && !e && this.config.onDrawerOpen(), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"), this.bindEvents()
            }
        }, t.prototype.close = function() {
            this.drawerIsOpen && (this.$open.removeClass(this.config.openClass), $(document.activeElement).trigger("blur"), this.nodes.$moved.prepareTransition({
                disableExisting: !0
            }), this.$drawer.prepareTransition({
                disableExisting: !0
            }), this.nodes.$parent.removeClass(this.config.dirOpenClass + " " + this.config.openClass), this.drawerIsOpen = !1, slate.a11y.removeTrapFocus({
                $container: this.$drawer,
                namespace: "drawer_focus"
            }), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false"), this.unbindEvents())
        }, t.prototype.bindEvents = function() {
            this.nodes.$page.on("touchmove.drawer", function() {
                return !1
            }), this.nodes.$page.on("click.drawer", $.proxy(function() {
                return this.close(), !1
            }, this)), this.nodes.$parent.on("keyup.drawer", $.proxy(function(t) {
                27 === t.keyCode && this.close()
            }, this))
        }, t.prototype.unbindEvents = function() {
            this.nodes.$page.off(".drawer"), this.nodes.$parent.off(".drawer")
        }, t
    }(), theme.Hero = function() {
        var t = {
                hero: ".hero",
                heroWrapper: ".hero-wrapper",
                heroContent: ".hero-content",
                heroTitle: ".hero-content__title",
                heroPause: ".hero__pause",
                heroAdapt: ".hero--adapt",
                heroControlsArrow: ".hero-content__controls-item--arrow",
                heroControlsCount: ".hero-content__controls-item--count",
                heroControlsText: ".hero-content__controls-item--text"
            },
            e = {
                heroContentActive: "hero-content-active",
                heroTitleActive: "hero-title-active",
                heroLinkActive: "hero-link-active",
                isPaused: "is-paused"
            };

        function i(e) {
            this.namespace = ".hero", this.$hero = $(e), this.$wrapper = this.$hero.closest(t.heroWrapper), this.$heroContent = this.$wrapper.find(t.heroContent), this.$heroPause = this.$wrapper.find(t.heroPause), this.$heroControlsArrow = this.$wrapper.find(t.heroControlsArrow), this.$heroAdapt = this.$wrapper.find(t.heroAdapt), this.$hero.on("init" + this.namespace, this._a11y.bind(this)), this.$hero.on("init" + this.namespace, this._arrowsInit.bind(this)), this.$hero.on("init reInit afterChange" + this.namespace, this._countSlide.bind(this)), this.$hero.on("init reInit afterChange" + this.namespace, this._showActiveContent.bind(this)), this.$hero.on("init reInit afterChange" + this.namespace, this._showContent.bind(this)), this.$hero.on("beforeChange" + this.namespace, this._hideContent.bind(this));
            var i = this.$hero.data("adapt-height");
            this.$hero.slick({
                accessibility: !0,
                arrows: !1,
                draggable: !1,
                autoplay: this.$hero.data("autoplay"),
                autoplaySpeed: this.$hero.data("speed")
            }), i && (this._setSlideshowHeight(), $(window).resize($.debounce(50, this._setSlideshowHeight.bind(this)))), this.$heroPause.on("click" + this.namespace, this._togglePause.bind(this))
        }
        return i.prototype = _.assignIn({}, i.prototype, {
            _setSlideshowHeight: function() {
                var t = this.$hero.data("min-aspect-ratio");
                this.$hero.height(this.$heroAdapt.width() / t)
            },
            _countSlide: function(e, i, n) {
                var a = (n || 0) + 1,
                    s = this.$wrapper.find(t.heroControlsCount);
                i.slideCount > 1 && (s.attr("aria-label", theme.strings.slideNumber.replace("[slide_number]", a)), s.children(".slide-counter").text(a + "/" + i.slideCount))
            },
            _showActiveContent: function(i, n, a) {
                var a = a || 0,
                    s = this.$wrapper.find(t.heroControlsText),
                    o = this.$wrapper.find(t.heroTitle);
                if (n.slideCount > 1) {
                    var r = o.filter('[data-slide-id="' + (a + 1) + '"]'),
                        c = s.filter('[data-slide-id="' + (a + 1) + '"]');
                    o.removeClass(e.heroTitleActive), r.addClass(e.heroTitleActive), s.removeClass(e.heroLinkActive), c.addClass(e.heroLinkActive)
                }
            },
            _hideContent: function() {
                this.$heroContent.removeClass(e.heroContentActive)
            },
            _showContent: function() {
                this.$heroContent.addClass(e.heroContentActive)
            },
            _togglePause: function() {
                if (this.$heroPause.hasClass(e.isPaused)) {
                    var t = this.$heroPause.data("label-pause");
                    this.$heroPause.removeClass(e.isPaused).attr({
                        "aria-pressed": "false",
                        "aria-label": t
                    }), this.play()
                } else {
                    var i = this.$heroPause.data("label-play");
                    this.$heroPause.addClass(e.isPaused).attr({
                        "aria-pressed": "true",
                        "aria-label": i
                    }), this.pause()
                }
            },
            _a11y: function(i, n) {
                var a = n.$list,
                    s = $(i.currentTarget).parents(t.heroWrapper),
                    o = this.$hero.data("autoplay");
                a.removeAttr("aria-live"), this.$heroContent.removeAttr("aria-live"), s.on("focusin" + this.namespace, (function(t) {
                    s.has(t.target).length && (this.$heroContent.attr("aria-live", "polite"), o && this.pause())
                }).bind(this)).on("focusout" + this.namespace, (function(t) {
                    !s.has(t.relatedTarget).length && (this.$heroContent.removeAttr("aria-live"), o && !this.$heroPause.hasClass(e.isPaused) && this.play())
                }).bind(this)).on("keyup", this._keyboardNavigation.bind(this))
            },
            _arrowsInit: function(t, e) {
                var i = e.slideCount,
                    n = e.$slider,
                    a = this.$heroControlsArrow;
                a.length && i > 1 ? a.on("click" + this.namespace, (function(t) {
                    t.preventDefault();
                    var e = $(t.currentTarget).find("button").data("control");
                    "previous" === e ? n.slick("slickPrev") : "next" === e && n.slick("slickNext"), this._scrollTop()
                }).bind(this)) : a.remove()
            },
            _scrollTop: function() {
                var t = $(document).scrollTop(),
                    e = this.$hero.offset().top;
                t > e && $("html").add("body").animate({
                    scrollTop: e
                }, 250)
            },
            _keyboardNavigation: function(t) {
                37 === t.keyCode && this.$hero.slick("slickPrev"), 39 === t.keyCode && this.$hero.slick("slickNext")
            },
            goToSlide: function(t) {
                this.$hero.slick("slickGoTo", t)
            },
            pause: function() {
                this.$hero.data("autoplay") && this.$hero.slick("slickPause")
            },
            play: function() {
                this.$hero.data("autoplay") && this.$hero.slick("slickPlay")
            },
            destroy: function() {
                this.$hero.off(this.namespace), this.$heroContent.off(this.namespace), this.$heroPause.off(this.namespace), this.$wrapper.off(this.namespace), this.$heroControlsArrow.off(this.namespace), this.$heroAdapt.off(this.namespace), this.$hero.slick("unslick")
            }
        }), i
    }(), window.Modals = function() {
        var t = function(t, e, i) {
            if (this.$modal = $("#" + t), !this.$modal.length) return !1;
            this.nodes = {
                $body: $("body")
            }, this.config = $.extend({
                close: ".js-modal-close",
                open: ".js-modal-open-" + e,
                openClass: "modal--is-active"
            }, i), this.modalIsOpen = !1, this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal, this.init()
        };
        return t.prototype.init = function() {
            $(this.config.open).attr("aria-expanded", "false"), $(this.config.open).on("click", $.proxy(this.open, this)), this.$modal.find(this.config.close).on("click", $.proxy(this.close, this))
        }, t.prototype.open = function(t) {
            var e = !1;
            if (!this.modalIsOpen) {
                if (t ? t.preventDefault() : e = !0, t && t.stopPropagation && (t.stopPropagation(), this.$activeSource = $(t.currentTarget)), this.modalIsOpen && !e) return this.close();
                this.$modal.prepareTransition().addClass(this.config.openClass), this.nodes.$body.addClass(this.config.openClass), this.modalIsOpen = !0, slate.a11y.trapFocus({
                    $container: this.$modal,
                    namespace: "modal_focus",
                    $elementToFocus: this.$focusOnOpen
                }), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"), this.bindEvents()
            }
        }, t.prototype.close = function() {
            this.modalIsOpen && ($(document.activeElement).trigger("blur"), this.$modal.prepareTransition().removeClass(this.config.openClass), this.nodes.$body.removeClass(this.config.openClass), this.modalIsOpen = !1, slate.a11y.removeTrapFocus({
                $container: this.$modal,
                namespace: "modal_focus"
            }), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false").focus(), this.unbindEvents())
        }, t.prototype.bindEvents = function() {
            this.nodes.$body.on("keyup.modal", $.proxy(function(t) {
                27 === t.keyCode && this.close()
            }, this))
        }, t.prototype.unbindEvents = function() {
            this.nodes.$body.off(".modal")
        }, t
    }(), window.Meganav = function() {
        var t = function(t) {
            this.cache = {
                $document: $(document),
                $page: $(".page-element")
            };
            var e = {
                $meganavs: $(".meganav"),
                $megaNav: $(".meganav__nav"),
                $meganavToggle: $(".meganav-toggle"),
                $meganavDropdownContainers: $(".site-nav__dropdown-container"),
                $meganavToggleThirdLevel: $(".meganav__link-toggle"),
                $meganavLinkSecondLevel: $(".meganav__link--second-level"),
                $meganavLinkThirdLevel: $(".meganav__link--third-level"),
                $meganavDropdownThirdLevel: $(".site-nav__dropdown--third-level"),
                isOpen: !1,
                preventDuplicates: !1,
                closeOnPageClick: !1,
                closeThirdLevelOnBlur: !1,
                activeClass: "meganav--active",
                drawerClass: "meganav--drawer",
                meganavDropdown: ".site-nav__dropdown",
                meganavLinkClass: "meganav__link",
                drawerToggleClass: "drawer__nav-toggle-btn",
                drawerNavItem: ".drawer__nav-item",
                navCollectionClass: "meganav__nav--collection",
                secondLevelClass: "meganav__link--second-level",
                thirdLevelClass: "meganav__link-toggle",
                thirdLevelContainerClass: "site-nav__dropdown--third-level",
                noAnimationClass: "meganav--no-animation"
            };
            this.config = $.extend(e, t), this.init()
        };
        return t.prototype.init = function() {
            this.config.$meganavToggle.on("click", $.proxy(this.requestMeganav, this)), this.config.closeThirdLevelOnBlur && this.config.$meganavLinkThirdLevel.on("blur", $.proxy(this.closeThirdLevelMenu, this))
        }, t.prototype.requestMeganav = function(t) {
            t && t.preventDefault(), t && t.stopPropagation && t.stopPropagation();
            var e, i = $(t.currentTarget),
                n = this.config.isOpen,
                a = i.hasClass(this.config.thirdLevelClass);
            if (e = i.hasClass(this.config.drawerToggleClass) ? i.closest(this.config.drawerNavItem).children("." + this.config.drawerClass) : i.siblings(this.config.meganavDropdown), i.hasClass(this.config.activeClass) && i.is("a")) {
                window.location = i.attr("href");
                return
            }
            if (!a && this.config.preventDuplicates && this.close(), e.hasClass(this.config.drawerClass)) {
                var s = "true" === i.attr("aria-expanded");
                i.toggleClass(this.config.activeClass).attr("aria-expanded", !s), e.stop().slideToggle(200)
            } else i.addClass(this.config.activeClass).attr("aria-expanded", "true"), this.open(i, e, n);
            this.bindEvents(), this.config.isOpen = !0;
            var o = i.next();
            o.find(this.config.$megaNav).hasClass(this.config.navCollectionClass) && this.updateThirdLevelContainerWidth(i, o)
        }, t.prototype.updateThirdLevelContainerWidth = function(t, e) {
            var i = e.find(this.config.$meganavDropdownThirdLevel);
            i.length && $.each(i, (function(t, e) {
                var i = $(e),
                    n = i.find("li:last-child");
                this.updateContainerWidth(i, n)
            }).bind(this))
        }, t.prototype.updateContainerWidth = function(t, e) {
            var i = t[0].getBoundingClientRect(),
                n = e[0].getBoundingClientRect();
            if (!(n.left < i.right)) {
                var a = i.width,
                    s = (n.left + a - i.left) / a;
                t.width(20 * s + "%").find("li").css("width", 100 / s + "%")
            }
          
        }, t.prototype.open = function(t, e, i) {
            var n = t.hasClass(this.config.thirdLevelClass);
            e.addClass(this.config.activeClass), n && this.toggleSubNav(t, e), i && e.addClass(this.config.noAnimationClass)
        }, t.prototype.toggleSubNav = function(t) {
            this.removeMenuActiveState(), t.addClass(this.config.activeClass).attr("aria-expanded", "true").siblings(this.config.$meganavDropdownThirdLevel).addClass(this.config.activeClass), t.parent().addClass(this.config.activeClass)
        }, t.prototype.close = function(t, e) {
            this.config.preventDuplicates ? (this.config.$meganavs.removeClass([this.config.activeClass, this.config.noAnimationClass].join(" ")), this.config.$meganavToggle.removeClass(this.config.activeClass).attr("aria-expanded", "false"), this.config.$meganavDropdownContainers.removeClass(this.config.activeClass)) : ($("#" + e.attr("aria-controls")).removeClass([this.config.activeClass, this.config.noAnimationClass].join(" ")), e.removeClass(this.config.activeClass).attr("aria-expanded", "false")), this.unbindEvents(), this.config.isOpen = !1
        }, t.prototype.closeThirdLevelMenu = function(t) {
            $(t.currentTarget).parent().is(":last-child") && this.config.$meganavLinkSecondLevel.one("focus.meganav", $.proxy(function() {
                this.removeMenuActiveState()
            }, this))
        }, t.prototype.removeMenuActiveState = function() {
            var t = [this.config.activeClass, this.config.noAnimationClass];
            this.config.$meganavToggleThirdLevel.removeClass(t.join(" ")).attr("aria-expanded", "false"), this.config.$meganavDropdownThirdLevel.removeClass(t.join(" ")), this.config.$meganavDropdownContainers.removeClass(this.config.activeClass)
        }, t.prototype.bindEvents = function() {
            this.config.closeOnPageClick && (this.cache.$page.on("click.meganav", $.proxy(this.close, this)), this.config.$meganavs.on("click.meganav", (function(t) {
                var e = $(t.currentTarget).hasClass(this.config.activeClass) && $(t.currentTarget).hasClass(this.config.thirdLevelContainerClass),
                    i = $(t.target).hasClass(this.config.meganavLinkClass) && $(t.target).hasClass(this.config.secondLevelClass);
                e || i || this.removeMenuActiveState(), t.stopImmediatePropagation()
            }).bind(this)), this.cache.$document.on("keyup.meganav", $.proxy(function(t) {
                27 === t.keyCode && (this.config.$meganavToggle.filter("." + this.config.activeClass).focus(), this.close())
            }, this)))
        }, t.prototype.unbindEvents = function() {
            this.config.closeOnPageClick && (this.cache.$page.off(".meganav"), this.config.$meganavs.off(".meganav"), this.cache.$document.off(".meganav"), this.config.$meganavLinkSecondLevel.off(".meganav"), this.config.$meganavLinkThirdLevel.off(".meganav"))
        }, t
    }(), window.QtySelector = function() {
        var t = function(t) {
            this.cache = {
                $body: $("body"),
                $subtotal: $("#CartSubtotal"),
                $discountTotal: $("#cartDiscountTotal"),
                $cartTable: $(".cart-table"),
                $cartTemplate: $("#CartProducts"),
                $cartFooter: $("#CartFooter"),
                $cartFooterTemplate: $("#CartFooterTemplate")
            }, this.settings = {
                loadingClass: "js-qty--is-loading",
                isCartTemplate: this.cache.$body.hasClass("template-cart"),
                minQty: this.cache.$body.hasClass("template-cart") ? 0 : 1
            }, this.$el = t, this.qtyUpdateTimeout, this.createInputs(), this.bindEvents()
        };
        return t.prototype.createInputs = function() {
            var t = this.$el,
                e = {
                    value: t.val(),
                    key: t.attr("id"),
                    name: t.attr("name"),
                    line: t.attr("data-line")
                },
                i = $("#QuantityTemplate").html(),
                n = Handlebars.compile(i);
            this.$wrapper = $(n(e)).insertBefore(t), t.remove()
        }, t.prototype.validateAvailability = function(t, e) {
            var i = theme.cartObject.items[t - 1],
                n = i.handle,
                a = i.id,
                s = {
                    type: "GET",
                    url: "/products/" + n + ".js",
                    dataType: "json",
                    success: $.proxy(function(i) {
                        this.validateAvailabilityCallback(t, e, a, i)
                    }, this)
                };
            $.ajax(s)
        }, t.prototype.validateAvailabilityCallback = function(t, e, i, n) {
            for (var a = !0, s = 0; s < n.variants.length; s++) {
                var o = n.variants[s];
                if (o.id === i) break
            }
            null !== o.inventory_management && "deny" === o.inventory_policy && o.inventory_quantity < e && (theme.Notify.open("error", theme.strings.noStockAvailable, !0), this.$wrapper.find(".js-qty__input").val(o.inventory_quantity), a = !1, this.$wrapper.removeClass(this.settings.loadingClass)), a && this.updateItemQuantity(t, e)
        }, t.prototype.validateQty = function(t) {
            return (parseFloat(t) !== parseInt(t, 10) || isNaN(t)) && (t = 1), parseInt(t, 10)
        }, t.prototype.adjustQty = function(t) {
            var e = $(t.currentTarget),
                i = e.siblings(".js-qty__input"),
                n = this.validateQty(i.val()),
                a = i.attr("data-line");
            e.hasClass("js-qty__adjust--minus") ? (n -= 1) <= this.settings.minQty && (n = this.settings.minQty) : n += 1, this.settings.isCartTemplate ? (e.parent().addClass(this.settings.loadingClass), this.updateCartItemPrice(a, n)) : i.val(n)
        }, t.prototype.bindEvents = function() {
            this.$wrapper.find(".js-qty__adjust").on("click", $.proxy(this.adjustQty, this)), this.$wrapper.on("click", ".js-qty__input", function() {
                this.setSelectionRange(0, this.value.length)
            }), this.settings.isCartTemplate && this.$wrapper.on("change", ".js-qty__input", $.proxy(function(t) {
                var e = $(t.currentTarget),
                    i = e.attr("data-line"),
                    n = this.validateQty(e.val());
                e.parent().addClass(this.settings.loadingClass), this.updateCartItemPrice(i, n)
            }, this))
        }, t.prototype.updateCartItemPrice = function(t, e) {
            clearTimeout(this.qtyUpdateTimeout), this.qtyUpdateTimeout = setTimeout($.proxy(function() {
                this.validateAvailability(t, e)
            }, this), 200)
        }, t.prototype.updateItemQuantity = function(t, e) {
            var i = {
                type: "POST",
                url: "/cart/change.js",
                data: "quantity=" + e + "&line=" + t,
                dataType: "json",
                success: $.proxy(function(t) {
                    this.updateCartItemCallback(t)
                }, this)
            };
            $.ajax(i)
        }, t.prototype.updateCartItemCallback = function(e) {
            if (0 === e.item_count) {
                location.reload();
                return
            }
            theme.cartObject = e;
            var i, n = {},
                a = [],
                s = {},
                o = $("#CartProductTemplate").html(),
                r = Handlebars.compile(o);
            $.each(e.items, function(t, e) {
                if (i = null === e.image ? "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif" : e.image.replace(/(\.[^.]*)$/, "_240x240$1").replace("http:", ""), null !== e.properties && $.each(e.properties, function(t, i) {
                        "_" !== t.charAt(0) && i || delete e.properties[t]
                    }), 0 !== e.line_level_discount_allocations.length)
                    for (var n in e.line_level_discount_allocations) {
                        var o = e.line_level_discount_allocations[n].amount;
                        e.line_level_discount_allocations[n].formattedAmount = theme.Currency.formatMoney(o, theme.moneyFormat)
                    }
                var r = null;
                e.unit_price_measurement && (r = {
                    addRefererenceValue: 1 !== e.unit_price_measurement.reference_value,
                    price: theme.Currency.formatMoney(e.unit_price, theme.moneyFormat),
                    reference_value: e.unit_price_measurement.reference_value,
                    reference_unit: e.unit_price_measurement.reference_unit
                }), s = {
                    key: e.key,
                    line: t + 1,
                    url: e.url,
                    img: i,
                    name: e.product_title,
                    variation: e.variant_title,
                    sellingPlanAllocation: e.selling_plan_allocation,
                    properties: e.properties,
                    itemQty: e.quantity,
                    price: theme.Currency.formatMoney(e.price, theme.moneyFormat),
                    vendor: e.vendor,
                    unitPrice: r,
                    linePrice: theme.Currency.formatMoney(e.final_line_price, theme.moneyFormat),
                    originalLinePrice: theme.Currency.formatMoney(e.original_line_price, theme.moneyFormat),
                    discounts: e.line_level_discount_allocations,
                    discountsApplied: 0 !== e.line_level_discount_allocations.length
                }, a.push(s)
            }), n = {
                items: a
            }, this.cache.$cartTemplate.empty().append(r(n)), this.updateCartFooter(e), this.cache.$cartTable.find('input[type="number"]').each(function(e, i) {
                new t($(i))
            }), slate.a11y.pageLinkFocus(this.cache.$cartTable)
        }, t.prototype.updateCartFooter = function(t) {
            if (0 !== t.cart_level_discount_applications.length)
                for (var e in t.cart_level_discount_applications) {
                    var i = t.cart_level_discount_applications[e].total_allocated_amount;
                    t.cart_level_discount_applications[e].formattedAmount = theme.Currency.formatMoney(i, theme.moneyFormat)
                }
            var n = this.cache.$cartFooterTemplate.html(),
                a = Handlebars.compile(n),
                s = {
                    totalPrice: theme.Currency.formatMoney(t.total_price, theme.moneyFormat),
                    cartDiscounts: t.cart_level_discount_applications,
                    cartDiscountsApplied: 0 !== t.cart_level_discount_applications.length
                };
            this.cache.$cartFooter.empty().append(a(s))
        }, t
    }(), window.AjaxCart = function() {
        var t = function(t) {
            this.cache = {
                $cartIconIndicator: $(".site-header__cart-indicator")
            }, this.$form = t, this.eventListeners()
        };
        return t.prototype.eventListeners = function() {
            this.$form.length && this.$form.on("submit", $.proxy(this.addItemFromForm, this))
        }, t.prototype.addItemFromForm = function(t) {
            t.preventDefault();
            var e = {
                type: "POST",
                url: "/cart/add.js",
                data: this.$form.serialize(),
                dataType: "json",
                success: $.proxy(function(t) {
                    this.success(t)
                }, this),
                error: $.proxy(function(t, e) {
                    this.error(t, e)
                }, this)
            };
            $.ajax(e)
        }, t.prototype.success = function() {
            theme.Notify.open("success", !1, !0), this.cache.$cartIconIndicator.removeClass("hide")
        }, t.prototype.error = function(t) {
            var e = JSON.parse(t.responseText);
            e.message && theme.Notify.open("error", e.description, !0)
        }, t
    }(), window.Notify = function() {
        var t = function() {
            this.cache = {
                $scrollParent: $("html").add("body"),
                $notificationSuccess: $("#NotificationSuccess"),
                $notificationSuccessLink: $("#NotificationSuccess").find("a"),
                $notificationError: $("#NotificationError"),
                $notificationPromo: $("#NotificationPromo"),
                $notificationClose: $(".notification__close"),
                $notificationErrorMessage: $(".notification__message--error")
            }, this.settings = {
                notifyActiveClass: "notification--active",
                closeTimer: 5e3,
                promoKeyName: "promo-" + this.cache.$notificationPromo.data("text")
            }, this.notifyTimer, this.$lastFocusedElement = null, this.isLocalStorageSupported = function t() {
                if (window.self !== window.top) return !1;
                var e = "test";
                try {
                    var i = window.sessionStorage;
                    return i.setItem(e, "1"), i.removeItem(e), !0
                } catch (n) {
                    return !1
                }
            }(), this.cache.$notificationClose.on("click", this.close.bind(this)), this.showPromo(), this.adaptNotification()
        };
        return t.prototype.open = function(t, e, i) {
            this.close(), "success" === t ? (this.cache.$notificationSuccess.attr("aria-hidden", !1).addClass(this.settings.notifyActiveClass), this.$lastFocusedElement = $(document.activeElement), this.cache.$notificationSuccess.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", $.proxy(function() {
                slate.a11y.pageLinkFocus(this.cache.$notificationSuccessLink)
            }, this)), this.cache.$scrollParent.hasClass("no-csstransitions") && slate.a11y.pageLinkFocus(this.cache.$notificationSuccessLink)) : (this.cache.$notificationErrorMessage.html(e), this.cache.$notificationError.attr("aria-hidden", !1).addClass(this.settings.notifyActiveClass)), i && (clearTimeout(this.notifyTimer), this.notifyTimer = setTimeout(this.close.bind(this), this.settings.closeTimer))
        }, t.prototype.close = function(t) {
            t && "NotificationPromoClose" === $(t.currentTarget).attr("id") && this.isLocalStorageSupported && localStorage.setItem(this.settings.promoKeyName, "hidden"), this.$lastFocusedElement && this.cache.$notificationSuccessLink.is(":focus") && slate.a11y.pageLinkFocus(this.$lastFocusedElement), this.cache.$notificationSuccess.attr("aria-hidden", !0).removeClass(this.settings.notifyActiveClass), this.cache.$notificationError.attr("aria-hidden", !0).removeClass(this.settings.notifyActiveClass), this.cache.$notificationPromo.attr("aria-hidden", !0).removeClass(this.settings.notifyActiveClass), this.$lastFocusedElement = null
        }, t.prototype.showPromo = function(t) {
            t && this.initCache(), (!this.isLocalStorageSupported || "hidden" !== localStorage[this.settings.promoKeyName]) && this.cache.$notificationPromo.attr("aria-hidden", !1).addClass(this.settings.notifyActiveClass)
        }, t.prototype.adaptNotification = function() {
            var t = $(".hero").data("adapt-height"),
                e = $("#NotificationPromo"),
                i = e.children(".notification__inner");
            e.length && (e.toggleClass("notification-adapt page-width", !0 === t), i.toggleClass("page-width", !1 === t))
        }, t
    }(), theme.Maps = function() {
        var t = {
                zoom: 14,
                styles: [{
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [{
                        color: "#cacaca"
                    }, {
                        lightness: 17
                    }]
                }, {
                    featureType: "landscape",
                    elementType: "geometry",
                    stylers: [{
                        color: "#e1e1e1"
                    }, {
                        lightness: 20
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "geometry.fill",
                    stylers: [{
                        color: "#ffffff"
                    }, {
                        lightness: 17
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "geometry.stroke",
                    stylers: [{
                        color: "#ffffff"
                    }, {
                        lightness: 29
                    }, {
                        weight: .2
                    }]
                }, {
                    featureType: "road.arterial",
                    elementType: "geometry",
                    stylers: [{
                        color: "#ffffff"
                    }, {
                        lightness: 18
                    }]
                }, {
                    featureType: "road.local",
                    elementType: "geometry",
                    stylers: [{
                        color: "#ffffff"
                    }, {
                        lightness: 16
                    }]
                }, {
                    featureType: "poi",
                    elementType: "geometry",
                    stylers: [{
                        color: "#e1e1e1"
                    }, {
                        lightness: 21
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "geometry",
                    stylers: [{
                        color: "#bbbbbb"
                    }, {
                        lightness: 21
                    }]
                }, {
                    elementType: "labels.text.stroke",
                    stylers: [{
                        visibility: "on"
                    }, {
                        color: "#ffffff"
                    }, {
                        lightness: 16
                    }]
                }, {
                    elementType: "labels.text.fill",
                    stylers: [{
                        saturation: 36
                    }, {
                        color: "#333333"
                    }, {
                        lightness: 40
                    }]
                }, {
                    elementType: "labels.icon",
                    stylers: [{
                        visibility: "off"
                    }]
                }, {
                    featureType: "transit",
                    elementType: "geometry",
                    stylers: [{
                        color: "#f2f2f2"
                    }, {
                        lightness: 19
                    }]
                }, {
                    featureType: "administrative",
                    elementType: "geometry.fill",
                    stylers: [{
                        color: "#fefefe"
                    }, {
                        lightness: 20
                    }]
                }, {
                    featureType: "administrative",
                    elementType: "geometry.stroke",
                    stylers: [{
                        color: "#fefefe"
                    }, {
                        lightness: 17
                    }, {
                        weight: 1.2
                    }]
                }]
            },
            e = null,
            i = [];

        function n(t) {
            theme.$currentMapContainer = this.$container = $(t);
            var n = this.$container.data("api-key");
            if ("string" == typeof n && "" !== n) {
                if ("loaded" === e) {
                    var a = this;
                    0 === $('script[src*="' + n + '&"]').length ? $.getScript("https://maps.googleapis.com/maps/api/js?key=" + n).then(function() {
                        e = "loaded", a.createMap()
                    }) : this.createMap()
                } else i.push(this), "loading" !== e && (e = "loading", void 0 === window.google && $.getScript("https://maps.googleapis.com/maps/api/js?key=" + n).then(function() {
                    e = "loaded", $.each(i, function(t, e) {
                        e.createMap()
                    })
                }))
            }
        }
        return n.prototype = _.assignIn({}, n.prototype, {
            createMap: function() {
                var e, i, n, a, s = this.$container.find(".map-section__container");
                return (e = s, i = $.Deferred(), n = new google.maps.Geocoder, a = e.data("address-setting"), n.geocode({
                    address: a
                }, function(t, e) {
                    e !== google.maps.GeocoderStatus.OK && i.reject(e), i.resolve(t)
                }), i).then((function(e) {
                    var i = {
                            zoom: t.zoom,
                            styles: t.styles,
                            center: e[0].geometry.location,
                            draggable: !1,
                            clickableIcons: !1,
                            scrollwheel: !1,
                            disableDoubleClickZoom: !0,
                            disableDefaultUI: !0
                        },
                        n = this.map = new google.maps.Map(s[0], i),
                        a = this.center = n.getCenter(),
                        o = s.data("enable-pin"),
                        r = s.data("marker-color");
                    new google.maps.Marker({
                        map: n,
                        position: a,
                        icon: {
                            path: "M57.7,0C25.8,0,0,25.8,0,57.7C0,89.5,50,170,57.7,170s57.7-80.5,57.7-112.3C115.3,25.8,89.5,0,57.7,0z M57.7,85 c-14.9,0-27-12.1-27-27c0-14.9,12.1-27,27-27c14.9,0,27,12.1,27,27C84.7,72.9,72.6,85,57.7,85z",
                            fillColor: r,
                            fillOpacity: .9,
                            scale: .2,
                            strokeWeight: 0
                        },
                        visible: o
                    }), google.maps.event.addDomListener(window, "resize", $.debounce(250, function() {
                        google.maps.event.trigger(n, "resize"), n.setCenter(a)
                    }))
                }).bind(this)).fail(function() {
                    var t;
                    switch (status) {
                        case "ZERO_RESULTS":
                            t = theme.strings.addressNoResults;
                            break;
                        case "OVER_QUERY_LIMIT":
                            t = theme.strings.addressQueryLimit;
                            break;
                        default:
                            t = theme.strings.addressError
                    }
                    if (Shopify.designMode) {
                        var e = s.parents(".map-section");
                        e.addClass("page-width map-section--load-error"), e.find(".map-section__content-wrapper").remove(), e.find(".map-section__wrapper").html('<div class="errors text-center" style="width: 100%;">' + t + "</div>")
                    }
                })
            },
            onUnload: function() {
                void 0 !== window.google && google.maps.event.clearListeners(this.map, "resize")
            }
        }), n
    }(), theme.stickyHeader = function() {
        var t = {
                searchCartWrapper: "#SiteNavSearchCart",
                stickyNavSearchCart: "#StickyNavSearchCart",
                stickyNavWrapper: "#StickNavWrapper",
                stickyBar: "#StickyBar"
            },
            e = {
                lastScroll: 0,
                navClass: "sticky--active",
                openTransitionClass: "sticky--open",
                closeTransitionClass: "sticky--close"
            },
            i = {};

        function n() {
            var n = i.$window.scrollTop(),
                a = $(t.stickyNavWrapper),
                s = a.offset().top + a.height() + 10;
            n < e.lastScroll && (s = a.offset().top), n > s ? !e.isActive && (e.isActive = !0, i.$stickyBar.addClass(e.navClass), setTimeout(function() {
                i.$stickyBar.addClass(e.openTransitionClass)
            }, 0)) : !!e.isActive && (i.$stickyBar.removeClass(e.openTransitionClass).removeClass(e.navClass), e.isActive = !1), e.lastScroll = n
        }
        return {
            init: function a() {
                i = {
                    $window: $(window),
                    $siteNavSearchCart: $(t.searchCartWrapper),
                    $stickyBar: $(t.stickyBar)
                }, e.isActive = !1, i.$siteNavSearchCart.contents().length && i.$siteNavSearchCart.contents().clone().appendTo($(t.stickyNavSearchCart)), i.$window.on("scroll.stickynav", $.throttle(15, n))
            },
            unload: function t() {
                $(window).off(".stickynav")
            }
        }
    }(), theme.headerNav = function() {
        var t = {
                siteNav: "#SiteNav",
                siteNavCompressed: "#SiteNavCompressed",
                siteNavParent: "#SiteNavParent",
                siteNavItem: ".site-nav__item",
                stickyNavWrapper: "#StickNavWrapper",
                stickyNav: "#StickyNav"
            },
            e = {
                lastScroll: 0,
                isActive: !1,
                navClass: "sticky--active",
                openTransitionClass: "sticky--open",
                closeTransitionClass: "sticky--close",
                searchInputClass: "site-header__search-input",
                searchSubmitClass: "site-header__search-submit",
                searchInnerActiveClass: "search-header__search-inner--active"
            };

        function i() {
            var e = 0,
                i = $(t.siteNavParent).width(),
                n = "hide";
            $(t.stickyNavWrapper).height($(t.stickyNav).height()), $(t.siteNav).removeClass(n), $(t.siteNavItem).each(function(t, i) {
                e += $(i).width()
            }), e > i ? ($(t.siteNav).addClass(n), $(t.siteNavCompressed).removeClass(n)) : ($(t.siteNav).removeClass(n), $(t.siteNavCompressed).addClass(n))
        }
        return {
            init: function t() {
                i(), new window.Meganav({
                    $meganavs: $(".site-nav__dropdown"),
                    $meganavToggle: $(".site-nav__link-toggle"),
                    preventDuplicates: !0,
                    closeOnPageClick: !0,
                    closeThirdLevelOnBlur: !0
                }), new window.Meganav({
                    $meganavs: $(".meganav--index"),
                    $meganavToggle: $(".index__meganav-toggle")
                }), new window.Meganav({
                    $meganavs: $(".meganav--drawer"),
                    $meganavToggle: $(".drawer__meganav-toggle")
                }), $(".site-header__search").each(function(t, i) {
                    var n = $(i),
                        a = n.find("." + e.searchInputClass),
                        s = n.find("." + e.searchSubmitClass);
                    a.add(s).on("focus blur", function() {
                        n.toggleClass("active-form")
                    }), s.on("mousedown", function() {
                        n.hasClass("active-form") && n.submit()
                    })
                }), window.matchMedia("(min-width: 750px)").matches && $(window).on("load", i), $(window).on("resize.headernav", $.debounce(250, i))
            },
            unload: function t() {
                $(window).off(".stickynav")
            }
        }
    }(), theme.customerTemplates = function() {
        function t() {
            $("#RecoverPasswordForm").toggleClass("hide"), $("#CustomerLoginForm").toggleClass("hide")
        }
        return {
            init: function() {
                var e;
                "#recover" === window.location.hash && t(), $("#RecoverPassword").on("click", function(e) {
                    e.preventDefault(), t()
                }), $("#HideRecoverPasswordLink").on("click", function(e) {
                    e.preventDefault(), t()
                }), $(".reset-password-success").length && $("#ResetSuccess").removeClass("hide"), e = $("#AddressNewForm"), e.length && (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
                    hideElement: "AddressProvinceContainerNew"
                }), $(".address-country-option").each(function() {
                    var t = $(this).data("form-id");
                    new Shopify.CountryProvinceSelector("AddressCountry_" + t, "AddressProvince_" + t, {
                        hideElement: "AddressProvinceContainer_" + t
                    })
                }), $(".address-new-toggle").on("click", function() {
                    e.toggleClass("hide")
                }), $(".address-edit-toggle").on("click", function() {
                    var t = $(this).data("form-id");
                    $("#EditAddress_" + t).toggleClass("hide")
                }), $(".address-delete").on("click", function() {
                    var t = $(this),
                        e = t.data("address-url");
                    confirm(t.data("confirm-message") || "Are you sure you wish to delete this address?") && Shopify.postLink(e, {
                        parameters: {
                            _method: "delete"
                        }
                    })
                }))
            }
        }
    }(), theme.HeaderSection = function() {
        function t() {
            var t;
            theme.stickyHeader.init(), theme.headerNav.init(), theme.Notify = new window.Notify, theme.NavDrawer = new window.Drawers("NavDrawer", "left"), t = $(".drawer__search-input"), $(".drawer__search-submit").on("click", function(e) {
                0 === t.val().length && (e.preventDefault(), t.focus())
            })
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            onSelect: function() {
                theme.Notify.adaptNotification()
            },
            onUnload: function() {
                theme.stickyHeader.unload(), theme.headerNav.unload()
            }
        }), t
    }(), theme.Filters = function() {
        var t = {
            filterSelection: "#SortTags",
            sortSelection: "#SortBy"
        };

        function e() {
            this.$filterSelect = $(t.filterSelection), this.$sortSelect = $(t.sortSelection), this.$filterSelect.on("change", this._onFilterChange.bind(this)), this.$sortSelect.on("change", this._onSortChange.bind(this))
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            _onFilterChange: function() {
                location.href = this.$filterSelect.val()
            },
            _onSortChange: function() {
                Shopify.queryParams.sort_by = this.$sortSelect.val(), Shopify.queryParams.page && delete Shopify.queryParams.page, location.search = decodeURIComponent($.param(Shopify.queryParams))
            },
            onUnload: function() {
                this.$filterSelect.off("change", this._onFilterChange), this.$sortSelect.off("change", this._onSortChange)
            }
        }), e
    }(), theme.Product = function() {
        var t = {
            smallBreakpoint: 750,
            productThumbIndex: 0,
            productThumbMax: 0,
            ajaxCart: !1,
            stockSetting: !1
        };

        function e(e) {
            var i = this.$container = $(e),
                n = i.attr("data-section-id");
            this.selectors = {
                originalSelectorId: "#ProductSelect-" + n,
                modal: "ProductModal",
                productZoomImage: "#ProductZoomImg",
                addToCart: "#AddToCart-" + n,
                productPrice: "#ProductPrice-" + n,
                comparePrice: "#ComparePrice-" + n,
                addToCartText: "#AddToCartText-" + n,
                SKU: ".variant-sku",
                productImageContainers: ".product__photo-container-" + n,
                productImageWrappers: ".product__photo-wrapper-" + n,
                productThumbContainers: ".product-single__thumbnail-item-" + n,
                productThumbsWrapper: ".product-single__thumbnails-" + n,
                productThumbs: ".product-single__thumbnail-" + n,
                saleTag: "#ProductSaleTag-" + n,
                productStock: "#ProductStock-" + n,
                singleOptionSelector: ".single-option-selector-" + n,
                shopifyPaymentButton: ".shopify-payment-button",
                unitPrice: "[data-unit-price]",
                unitPriceBaseUnit: "[data-unit-price-base-unit]",
                unitPriceContainer: "[data-unit-price-container]"
            }, this.settings = $.extend({}, t, {
                sectionId: n,
                ajaxCart: i.data("ajax"),
                stockSetting: i.data("stock"),
                enableHistoryState: i.data("enable-history-state") || !1,
                namespace: ".product-" + n
            }), $("#ProductJson-" + n).html() && (this.productSingleObject = JSON.parse($("#ProductJson-" + n).html()), this.addVariantInfo(), this.init())
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            init: function() {
                this._stringOverrides(), this._initVariants(), this._productZoomImage(), this._productThumbSwitch(), this._productThumbnailSlider(), this._initQtySelector(), this.settings.ajaxCart && (theme.AjaxCart = new window.AjaxCart($("#AddToCartForm-" + this.settings.sectionId)))
            },
            _stringOverrides: function() {
                window.productStrings = window.productStrings || {}, $.extend(theme.strings, window.productStrings)
            },
            addVariantInfo: function() {
                if (this.productSingleObject && this.settings.stockSetting)
                    for (var t = JSON.parse($("#VariantJson-" + this.settings.sectionId).html()), e = 0; e < t.length; e++) $.extend(this.productSingleObject.variants[e], t[e])
            },
            _initVariants: function() {
                var t = {
                    $container: this.$container,
                    enableHistoryState: this.settings.enableHistoryState,
                    product: this.productSingleObject,
                    singleOptionSelector: this.selectors.singleOptionSelector,
                    originalSelectorId: this.selectors.originalSelectorId
                };
                this.variants = new slate.Variants(t), this.$container.on("variantChange" + this.settings.namespace, this._updateVariantChange.bind(this)), this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this)), this.$container.on("variantSKUChange" + this.settings.namespace, this._updateSKU.bind(this)), this.$container.on("variantImageChange" + this.settings.namespace, this._updateImages.bind(this))
            },
            _updateStock: function(t) {
                if (this.settings.stockSetting) {
                    var e = $(this.selectors.productStock);
                    if (!t || !t.inventory_management) {
                        e.addClass("hide");
                        return
                    }
                    if (t.inventory_quantity < 10 && t.inventory_quantity > 0) {
                        e.html(theme.strings.stockAvailable.replace("1", t.inventory_quantity)).removeClass("hide");
                        return
                    }
                    if (t.inventory_quantity <= 0 && t.incoming) {
                        e.html(theme.strings.willNotShipUntil.replace("[date]", t.next_incoming_date)).removeClass("hide");
                        return
                    }
                    e.addClass("hide")
                }
            },
            _updateIncomingInfo: function(t) {
                if (this.settings.stockSetting) {
                    var e = $(this.selectors.productStock);
                    if (t.incoming) {
                        e.html(theme.strings.willBeInStockAfter.replace("[date]", t.next_incoming_date)).removeClass("hide");
                        return
                    }
                    e.addClass("hide")
                }
            },
            _updateVariantChange: function(t) {
                var e = t.variant,
                    i = {
                        $addToCart: $(this.selectors.addToCart),
                        $addToCartText: $(this.selectors.addToCartText)
                    };
                if (e) {
                    if (e.available ? (i.$addToCart.removeClass("btn--sold-out").prop("disabled", !1), i.$addToCartText.html(theme.strings.addToCart), $(this.selectors.shopifyPaymentButton, this.$container).show(), this._updateStock(e)) : (i.$addToCart.prop("disabled", !0).addClass("btn--sold-out"), i.$addToCartText.html(theme.strings.soldOut), $(this.selectors.shopifyPaymentButton, this.$container).hide(), this._updateIncomingInfo(e)), $(this.selectors.unitPriceContainer, this.$container).addClass("hide"), e.unit_price_measurement) {
                        var n = $(this.selectors.unitPrice, this.$container),
                            a = $(this.selectors.unitPriceBaseUnit, this.$container);
                        n.html(theme.Currency.formatMoney(e.unit_price, theme.moneyFormat)), a.html(this._getBaseUnit(e)), $(this.selectors.unitPriceContainer, this.$container).removeClass("hide")
                    }
                } else i.$addToCart.prop("disabled", !0).removeClass("btn--sold-out"), i.$addToCartText.html(theme.strings.unavailable), $(this.selectors.shopifyPaymentButton, this.$container).hide(), this._updateStock()
            },
            _updatePrice: function(t) {
                var e = t.variant;
                e ? ($(this.selectors.productPrice).html(theme.Currency.formatMoney(e.price, theme.moneyFormat)), e.compare_at_price > e.price ? ($(this.selectors.comparePrice).html(theme.Currency.formatMoney(e.compare_at_price, theme.moneyFormat)).removeClass("hide"), $(this.selectors.saleTag).removeClass("hide")) : ($(this.selectors.comparePrice).addClass("hide"), $(this.selectors.saleTag).addClass("hide"))) : $(this.selectors.comparePrice).addClass("hide")
            },
            _getBaseUnit: function(t) {
                return 1 === t.unit_price_measurement.reference_value ? t.unit_price_measurement.reference_unit : t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit
            },
            _updateSKU: function(t) {
                var e = t.variant;
                e && $(this.selectors.SKU).html(e.sku)
            },
            _updateImages: function(t) {
                var e = t.variant;
                if (e && e.featured_image) {
                    var i = e.featured_image.id;
                    this.switchProductImage(i), this.setActiveThumbnail(i)
                }
            },
            switchProductImage: function(t) {
                var e = $(this.selectors.productImageContainers + "[data-image-id='" + t + "']", this.$container);
                $(this.selectors.productImageContainers + ":not([data-image-id='" + t + "'])", this.$container).addClass("hide"), e.removeClass("hide")
            },
            setActiveThumbnail: function(t) {
                var e = $(this.selectors.productThumbContainers + "[data-image-id='" + t + "']", this.$container);
                $(this.selectors.productThumbContainers + ":not([data-image-id='" + t + "'])", this.$container).removeClass("is-active"), e.addClass("is-active");
                var i = $(this.selectors.productThumbsWrapper, this.$container);
                if (i.hasClass("slick-initialized")) {
                    var n = i.slick("slickCurrentSlide"),
                        a = parseInt(e.attr("data-slick-index"));
                    n !== a && i.slick("slickGoTo", a, !1)
                }
            },
            _productZoomImage: function() {
                if ($(".product-single " + this.selectors.productImageContainers).length) {
                    var t = this;
                    $(this.selectors.productImageWrappers).on("click" + this.settings.namespace, function(e) {
                        e.preventDefault(), $(t.selectors.productZoomImage).attr("src", "").attr("src", $(this).attr("href"))
                    }), this.ProductModal = new window.Modals(this.selectors.modal, "product-modal"), this.ProductModal.$modal.on("click" + this.settings.namespace, function(e) {
                        "IMG" !== e.target.nodeName && t.ProductModal.close()
                    })
                }
            },
            _productThumbSwitch: function() {
                if ($(this.selectors.productThumbs).length) {
                    var t = this;
                    $(this.selectors.productThumbs).on("click" + this.settings.namespace, function(e) {
                        e.preventDefault();
                        var i = $(this).parent().data("image-id");
                        t.setActiveThumbnail(i), t.switchProductImage(i)
                    })
                }
            },
            _productThumbnailSlider: function() {
                var t = $(this.selectors.productThumbsWrapper),
                    e = $(this.selectors.productThumbs);
                if (e.length && e.length > 2) {
                    t.on("init" + this.settings.namespace, this._productSwipeInit.bind(this));
                    var i, n, a = window.sliderArrows || !1;
                    a && (i = '<button type="button" class="slick-next"><span class="medium-up--hide">' + a.right + '</span><span class="small--hide">' + a.down + "</span></button>", n = '<button type="button" class="slick-prev"><span class="medium-up--hide">' + a.left + '</span><span class="small--hide">' + a.up + "</span></button>"), t.slick({
                        accessibility: !1,
                        arrows: !0,
                        dots: !1,
                        infinite: !1,
                        autoplay: !1,
                        slidesToShow: 6,
                        slidesToScroll: 6,
                        vertical: !0,
                        verticalSwiping: !0,
                        nextArrow: i,
                        prevArrow: n,
                        responsive: [{
                            breakpoint: this.settings.smallBreakpoint,
                            settings: {
                                vertical: !1,
                                verticalSwiping: !1
                            }
                        }]
                    }), t.slick("slickGoTo", t.find(".is-active").attr("data-slick-index"), !0)
                }
            },
            _productSwipeInit: function(t, e) {
                this.settings.productThumbIndex = e.currentSlide, this.settings.productThumbMax = e.slideCount - 1;
                var i = this;
                $(this.selectors.productImageWrappers).on("swipeleft swiperight", function(t) {
                    "swipeleft" === t.type && i._goToNextThumbnail(), "swiperight" === t.type && i._goToPrevThumbnail(), $('.product-single__thumbnail-item[data-slick-index="' + i.settings.productThumbIndex + '"]').find(".product-single__thumbnail").trigger("click")
                })
            },
            _goToNextThumbnail: function() {
                this.settings.productThumbIndex++, this.settings.productThumbIndex > this.settings.productThumbMax && (this.settings.productThumbIndex = 0), $(this.selectors.productThumbsWrapper).slick("slickGoTo", this.settings.productThumbIndex, !0)
            },
            _goToPrevThumbnail: function() {
                this.settings.productThumbIndex--, this.settings.productThumbIndex < 0 && (this.settings.productThumbIndex = this.settings.productThumbMax), $(this.selectors.productThumbsWrapper).slick("slickGoTo", this.settings.productThumbIndex, !0)
            },
            _initQtySelector: function() {
                this.$container.find(".product-form__quantity").each(function(t, e) {
                    new QtySelector($(e))
                })
            },
            onUnload: function() {
                $(this.selectors.productImageWrappers).off(this.settings.namespace), $(this.selectors.productThumbs).off(this.settings.namespace), $(this.selectors.productThumbs).slick("unslick"), this.ProductModal && this.ProductModal.$modal.off(this.settings.namespace)
            }
        }), e
    }(), theme.slideshows = {}, theme.Slideshow = function() {
        function t(t) {
            this.$container = $(t);
            var e = this.$container.attr("data-section-id");
            this.slideshow = "#Slideshow-" + e, theme.slideshows[this.slideshow] = new theme.Hero(this.slideshow)
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            onUnload: function() {
                theme.slideshows[this.slideshow].destroy()
            },
            onSelect: function() {
                theme.slideshows[this.slideshow].pause(), theme.Notify.adaptNotification()
            },
            onDeselect: function() {
                theme.slideshows[this.slideshow].play()
            },
            onBlockSelect: function(t) {
                var e = $(".hero__slide--" + t.detail.blockId + ":not(.slick-cloned)").data("slick-index");
                theme.slideshows[this.slideshow].pause(), theme.slideshows[this.slideshow].goToSlide(e)
            },
            onBlockDeselect: function() {
                theme.slideshows[this.slideshow].play()
            }
        }), t
    }(), theme.Cart = function() {
        var t = {
            cartNote: "#CartSpecialInstructions",
            cartQtyInput: ".cart__quantity",
            cartNoCookiesClass: "cart--no-cookies"
        };

        function e(t) {
            var e = this.$container = $(t),
                i = e.attr("data-section-id");
            theme.cartObject = JSON.parse($("#CartJson-" + i).html()), this.init(e)
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            init: function(e) {
                this._initQtySelector(), this._initCartNote(), this._cookiesEnabled() || e.addClass(t.cartNoCookiesClass)
            },
            _initQtySelector: function() {
                $(t.cartQtyInput).each(function(t, e) {
                    new QtySelector($(e))
                })
            },
            _initCartNote: function() {
                if ($(t.cartNote).length) {
                    var e, i, n = $(t.cartNote),
                        a = n[0].offsetHeight - n[0].clientHeight;
                    n.on("keyup input", function() {
                        $(this).css("height", "auto").css("height", n[0].scrollHeight + a)
                    }), n.on("change", $.proxy(function() {
                        e = n.val(), i = {
                            type: "POST",
                            url: "/cart/update.js",
                            data: "note=" + this._attributeToString(e),
                            dataType: "json"
                        }, $.ajax(i)
                    }, this))
                }
            },
            _attributeToString: function(t) {
                return "string" != typeof t && "undefined" === (t = String(t)) && (t = ""), $.trim(t)
            },
            _cookiesEnabled: function() {
                var t = navigator.cookieEnabled;
                return t || (document.cookie = "testcookie", t = -1 !== document.cookie.indexOf("testcookie")), t
            }
        }), e
    }(), theme.Quotes = function() {
        function t(t) {
            this.$container = $(t).on("init", this._a11y.bind(this)), this.$container.slick({
                accessibility: !0,
                arrows: !1,
                dots: !0,
                draggable: !0,
                autoplay: !1
            })
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _a11y: function(t, e) {
                var i = e.$list,
                    n = this.$container.parent();
                i.removeAttr("aria-live"), n.on("focusin", function(t) {
                    n.has(t.target).length && i.attr("aria-live", "polite")
                }), n.on("focusout", function(t) {
                    n.has(t.target).length && i.removeAttr("aria-live")
                })
            },
            _goToSlide: function(t) {
                this.$container.slick("slickGoTo", t)
            },
            onUnload: function() {
                delete this.$container
            },
            onBlockSelect: function(t) {
                var e = $(".quote__slide-wrapper--" + t.detail.blockId + ":not(.slick-cloned)").data("slick-index");
                this._goToSlide(e)
            }
        }), t
    }(), theme.Video = function() {
        var t, e, i = {
                promiseAPI: function() {
                    if (!t) {
                        var e = document.createElement("script");
                        e.src = "https://www.youtube.com/iframe_api";
                        var i = document.getElementsByTagName("script")[0];
                        i.parentNode.insertBefore(e, i), t = $.Deferred(function(t) {
                            window.onYouTubeIframeAPIReady = t.resolve, setTimeout(function() {
                                t.reject("Request for YouTube API timed out after 30 seconds.")
                            }, 3e4)
                        })
                    }
                    return t
                },
                promisePlayer: function(t, e) {
                    return this.promiseAPI().then(function() {
                        return $.Deferred(function(i) {
                            void 0 === window.YT && i.reject("We're sorry, something went wrong. The YouTube API has not loaded correctly.");
                            var n = new YT.Player(t, e);
                            n.addEventListener("onReady", function() {
                                i.resolve(n)
                            }), setTimeout(function() {
                                i.reject("Request for YouTube player has timed out after 30 seconds.")
                            }, 3e4)
                        })
                    })
                }
            },
            n = {
                promiseAPI: function() {
                    return e || (e = $.Deferred(function(t) {
                        var e = document.createElement("script");
                        e.src = "https://player.vimeo.com/api/player.js", e.onload = e.onreadystatechange = function() {
                            this.readyState && "complete" !== this.readyState || t.resolve()
                        };
                        var i = document.getElementsByTagName("script")[0];
                        i.parentNode.insertBefore(e, i), setTimeout(function() {
                            t.reject("Request for Vimeo API timed out after 30 seconds.")
                        }, 3e4)
                    })), e
                },
                promisePlayer: function(t, e) {
                    return this.promiseAPI().then(function() {
                        return $.Deferred(function(i) {
                            void 0 === window.Vimeo && i.reject("We're sorry, something went wrong. The Vimeo API has not loaded correctly.");
                            var n = new window.Vimeo.Player(t, e);
                            setTimeout(function() {
                                i.reject("Request for Vimeo player has timed out after 30 seconds.")
                            }, 3e4), n.ready().then(function() {
                                i.resolve(n)
                            })
                        })
                    })
                }
            },
            a = {
                loadPlayerButton: ".video-section__load-player-button",
                closePlayerButton: ".video-section__player-close",
                playerContainer: ".video-section__player",
                cover: ".video-section__cover",
                errorMessage: ".video-section__error",
                bodyOverlay: ".video-section__body-overlay",
                body: "body"
            },
            s = {
                playerLoading: "video-section--loading",
                playerLoaded: "video-section--loaded",
                playerError: "video-section--error",
                videoPlaying: "video-playing"
            };

        function o(t) {
            this.$container = $(t);
            var e = this.$container.attr("data-section-id");
            this.namespace = "." + e, this.onLoad()
        }
        return o.prototype = _.assignIn({}, o.prototype, {
            onLoad: function() {
                this.$container.on("click", a.loadPlayerButton, this._loadPlayer.bind(this)).on("click", a.closePlayerButton, this._closePlayer.bind(this)).on("click", a.bodyOverlay, this._closePlayer.bind(this))
            },
            _loadPlayer: function() {
                var t, e = this.$container,
                    i = $(a.playerContainer, e),
                    n = this.$container.attr("data-video-type");
                return "youtube" === n ? t = this._loadYoutubePlayer(i[0]) : "vimeo" === n && (t = this._loadVimeoPlayer(i[0])), t.then(this._onPlayerLoadReady.bind(this)).fail(this._onPlayerLoadError.bind(this))
            },
            _loadYoutubePlayer: function(t) {
                return i.promisePlayer(t, {
                    videoId: this.$container.attr("data-video-id"),
                    ratio: 16 / 9,
                    playerVars: {
                        modestbranding: 1,
                        autoplay: 1,
                        showinfo: 0,
                        rel: 0
                    }
                }).then((function(t) {
                    this.player = t
                }).bind(this))
            },
            _loadVimeoPlayer: function(t) {
                return n.promisePlayer(t, {
                    id: this.$container.attr("data-video-id")
                }).then((function(t) {
                    this.player = t, this.player.play()
                }).bind(this))
            },
            _onPlayerLoadReady: function() {
                $(a.closePlayerButton, this.$container).show().focus(), $(a.cover, this.$container).addClass(s.playerLoaded), this.$container.addClass(s.playerLoaded), this._setScrollPositionValues(), $(a.body).addClass(s.videoPlaying), $(document).on("keyup" + this.namespace, this._closeOnEscape.bind(this)), $(window).on("resize" + this.namespace, this._setScrollPositionValues.bind(this)), slate.a11y.trapFocus({
                    $container: this.$container,
                    namespace: this.namespace
                })
            },
            _onPlayerLoadError: function(t) {
                this.$container.addClass(s.playerError), $(a.errorMessage, this.$container).text(t)
            },
            _closeOnEscape: function(t) {
                27 === t.keyCode && (this._closePlayer(), $(a.loadPlayerButton, this.$container).focus())
            },
            _onScroll: function() {
                var t = $(window).scrollTop();
                (t > this.videoTop + .25 * this.videoHeight || t + this.windowHeight < this.videoBottom - .25 * this.videoHeight) && requestAnimationFrame(this._closePlayer.bind(this))
            },
            _setScrollPositionValues: function() {
                this.videoHeight = this.$container.outerHeight(!0), this.videoTop = this.$container.offset().top, this.videoBottom = this.videoTop + this.videoHeight, this.windowHeight = $(window).innerHeight()
            },
            _closePlayer: function() {
                $(a.body).removeClass(s.videoPlaying), $(a.cover, this.$container).removeClass(s.playerLoaded), this.$container.removeClass(s.playerLoaded), $(a.closePlayerButton, this.$container).hide(), slate.a11y.removeTrapFocus({
                    $container: this.$container,
                    namespace: this.namespace
                }), "function" == typeof this.player.destroy ? this.player.destroy() : "function" == typeof this.player.unload && this.player.unload(), $(document).off(this.namespace), $(window).off(this.namespace)
            }
        }), o
    }(), theme.CollectionsList = function() {
        function t(t) {
            var e = this.$container = $(t);
            if (!e.is("[data-stretch-image]")) {
                var i = this.namespace = "." + e.attr("data-section-id"),
                    n = this;
                n._collectionListFix(), $(window).on("resize" + i, $.debounce(250, function() {
                    n._collectionListFix()
                }))
            }
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            onUnload: function() {
                $(window).off(this.namespace)
            },
            _collectionListFix: function() {
                var t = this.$container.find(".grid").data("number-rows"),
                    e = this.$container.find(".featured-card");
                if (!e.is("[data-stretch-image]"))
                    for (var i = 0; i < t; i++) {
                        var n = 0,
                            a = 0,
                            s = e.filter("[data-row-number='" + (i + 1) + "']"),
                            o = s.find(".featured-card__header");
                        s.each(function() {
                            var t = $(this).find(".featured-card__title"),
                                e = $(this).find(".featured-card__action"),
                                i = $(this).find(".featured-card__image-wrapper"),
                                s = t.outerHeight() + e.outerHeight() + 65,
                                o = i.outerHeight();
                            s > a && (a = s), o > n && (n = o)
                        }), o.outerHeight(a), s.height(n + a + 40)
                    }
            }
        }), t
    }(), theme.ProductRecommendations = function t(e) {
        this.$container = $(e);
        var i = this.$container.data("baseUrl"),
            n = this.$container.data("productId");
        $.get(i + "?section_id=product-recommendations&product_id=" + n + "&limit=6").then((function(t) {
            var e = $(t).html();
            "" !== e.trim() && this.$container.html(e)
        }).bind(this))
    }, theme.init = function() {
        theme.customerTemplates.init(), slate.rte.wrapTable(), slate.rte.iframeReset(), slate.a11y.pageLinkFocus($(window.location.hash)), $(".in-page-link").on("click", function(t) {
            slate.a11y.pageLinkFocus($(t.currentTarget.hash))
        }), $('a[href="#"]').on("click", function(t) {
            t.preventDefault()
        });
        var t = new theme.Sections;
        t.register("header", theme.HeaderSection), t.register("product", theme.Product), t.register("featured-product", theme.Product), t.register("collection-filters", theme.Filters), t.register("map", theme.Maps), t.register("slideshow", theme.Slideshow), t.register("cart", theme.Cart), t.register("quotes", theme.Quotes), t.register("video", theme.Video), t.register("collections-list", theme.CollectionsList), t.register("product-recommendations", theme.ProductRecommendations), $(window).on("load", theme.articleImages), theme.passwordModalInit(), theme.productCardImageLoadingAnimation()
    }, theme.articleImages = function() {
        var t = $(".rte--indented-images");
        t.length && t.find("img").each(function(e, i) {
            var n = $(i),
                a = n.attr("style");
            (!a || "float: none;" === a) && n.width() >= t.width() && n.parent("p").addClass("rte__image-indent")
        })
    }, theme.passwordModalInit = function() {
        var t = $("#LoginModal");
        t.length && (theme.PasswordModal = new window.Modals("LoginModal", "login-modal", {
            focusOnOpen: "#Password"
        }), t.find(".errors").length && theme.PasswordModal.open())
    }, theme.productCardImageLoadingAnimation = function() {
        var t = {
                image: "[data-image]",
                imagePlaceholder: "[data-image-placeholder]",
                imageWithPlaceholderWrapper: "[data-image-with-placeholder-wrapper]"
            },
            e = {
                hidden: "placeholder-background--hide"
            };
        $(document).on("lazyloaded", function(i) {
            var n = $(i.target);
            n.is(t.image) && n.closest(t.imageWithPlaceholderWrapper).find(t.imagePlaceholder).addClass(e.hidden)
        }), $(t.image + ".lazyloaded").closest(t.imageWithPlaceholderWrapper).find(t.imagePlaceholder).addClass(e.hidden)
    }, $(theme.init),
    function(t) {
        var e = {
            trigger: "onload",
            animation: "fade",
            delay: 100,
            showOnce: !1,
            autoClose: !1,
            scrollableModal: !1
        };
        t.fn.websenseprosubscribe = function(i) {
            var n = t.extend({}, e, i),
                a = t(this),
                s = !1,
                o = !1;
            switch (a.addClass("sb"), t.fn.openWindow = function() {
                    t(this).is(":hidden") && !1 == s && !1 == o && (o = !0, setTimeout(function() {
                        !0 == n.scrollableModal ? t(".sb-overlay").length < 1 && (t("body").append("<div class='sb-overlay'><div class='sb-close-backdrop'></div><div class='sb sb-withoverlay'>" + t(".sb").html() + "</div></div>"), t(".sb-close-backdrop, .sb-close-btn").one("click", function() {
                            return t(".sb.sb-withoverlay").closeWindow(), !1
                        }), t(".sb.sb-withoverlay").removeClass("sb-animation-" + n.animation.replace("In", "Out")).addClass("sb-animation-" + n.animation), setTimeout(function() {
                            t(".sb.sb-withoverlay").show(), t("body").addClass("sb-open sb-open-with-overlay")
                        }, 300)) : t(".sb-overlay").length < 1 && (t("body").append("<div class='sb-overlay'><div class='sb-close-backdrop'></div></div>"), t(".sb").removeClass("sb-animation-" + n.animation.replace("In", "Out")).addClass("sb-animation-" + n.animation), t(".sb-close-backdrop, .sb-close-btn").one("click", function() {
                            return t(".sb").closeWindow(), !1
                        }), setTimeout(function() {
                            t(".sb").show(), t("body").addClass("sb-open")
                        }, 300)), !0 == n.showOnce && (s = !0), o = !1
                    }, n.delay))
                }, t.fn.closeWindow = function() {
                    t(this).is(":visible") && !1 == o && (o = !0, !0 == n.scrollableModal ? (t(".sb.sb-withoverlay").removeClass("sb-animation-" + n.animation).addClass("sb-animation-" + n.animation.replace("In", "Out")), setTimeout(function() {
                        t(".sb.sb-withoverlay").hide(), t("body").removeClass("sb-open sb-open-with-overlay"), setTimeout(function() {
                            t(".sb-overlay").remove()
                        }, 300)
                    }, 300)) : (t(".sb").removeClass("sb-animation-" + n.animation).addClass("sb-animation-" + n.animation.replace("In", "Out")), setTimeout(function() {
                        t(".sb").hide(), t("body").removeClass("sb-open"), setTimeout(function() {
                            t(".sb-overlay").remove()
                        }, 300)
                    }, 300)), o = !1)
                }, t.fn.scrollDetection = function(e, i) {
                    var n, a = new Date().getTime();
                    t(window).scroll(function() {
                        var e = new Date().getTime();
                        e - a > 400 && (t(this).trigger("scrollStart"), a = e), clearTimeout(n), n = setTimeout(function() {
                            t(window).trigger("scrollEnd")
                        }, 300)
                    }), "scrollStart" == e && t(window).bind("scrollStart", function() {
                        t(window).unbind("scrollEnd"), i()
                    }), "scrollEnd" == e && t(window).bind("scrollEnd", function() {
                        t(window).unbind("scrollStart"), i()
                    })
                }, n.trigger) {
                case "atendpage":
                    t(window).scroll(function() {
                        var e = t(window).scrollTop();
                        e >= t(document).height() - t(window).height() ? a.openWindow() : e + 300 < t(document).height() - t(window).height() && !0 == n.autoClose && a.closeWindow()
                    });
                    break;
                case "onload":
                    t(window).on("load", function() {
                        a.openWindow(), !0 == n.autoClose && a.scrollDetection("scrollStart", function() {
                            a.closeWindow()
                        })
                    });
                    break;
                case "onidle":
                    t(window).on("load", function() {
                        a.scrollDetection("scrollEnd", function() {
                            a.openWindow()
                        }), !0 == n.autoClose && a.scrollDetection("scrollStart", function() {
                            a.closeWindow()
                        })
                    })
            }
        }
    }(window.jQuery), $(document).ready(function() {
        "true" !== localStorage.popupShown && ($(".subscribe-me").websenseprosubscribe(), localStorage.popupShown = "true")
    });